import * as React from 'react';
import { SVGProps } from 'react';
export const SailBoatIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={41}
    fill="none"
    {...props}
  >
    <path
      stroke="#18191C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M31.5 23.641A20.55 20.55 0 0 0 18.333 6.975v18M10 26.041l8.333-15.733m4.45 23.333H7.6a1.666 1.666 0 0 1-1.667-1.283L5 28.641a1.666 1.666 0 0 1 1.45-2.15l26.667-2.883a1.667 1.667 0 0 1 1.666 2.517 13.55 13.55 0 0 1-12 7.516v0Z"
    />
  </svg>
);
